/* eslint-disable react-hooks/exhaustive-deps */
import { onAuthStateChanged } from "firebase/auth";
import { React, useState, useEffect, useCallback, useContext } from "react";
import { DeleteButton, EditButton, SubmitButton } from "../components/buttons";
import { Link } from "react-router-dom";
import { signOut, updateProfile } from "firebase/auth";
import { auth, db, storage } from "../firebase";
import ErrorBoundary from "../ErrorBoundary";
import { useUser } from "../data";
import { useNavigate } from "react-router-dom";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useTranslation } from "react-i18next";
import { raiseQuery } from "../data/query";
import { collection, query, where, getDocs } from "firebase/firestore";
import toast from "react-hot-toast";
import { Merge, PinchOutlined } from "@mui/icons-material";
import modifyPdf from "../data/pdfMaker";
import { sendQueryEmail } from "../data/emailService";
import ReferralRazorPay from "../components/ReferralRazorPay";
import ShareOptionsModal from "../components/ShareOptionsModal";
import ComputationPDF from "../components/ComputationPDF";

const Profile = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authUser = auth.currentUser;
  const userData = useUser();
  const pan =
    userData?.pan ||
    userData?.userdata?.pan ||
    (authUser?.email
      ? (authUser.email.match(/\+(.*?)@/)?.[1] || "").toUpperCase()
      : "") ||
    props.pan || "";
  console.log(userData);

  console.log(userData?.userdata?.aadharNo);
  const [edit, setEdit] = useState(false);
  const [editPrimary, setEditPrimary] = useState(false);
  const [editOtherEmp, setEditOtherEmp] = useState(false);
  const [itrStatus, setItrStatus] = useState(false);
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [aadhaar, setAadhaar] = useState("");
  // const [policeStation, setPoliceStation] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [Designation, setDesignation] = useState("");
  const [TAN, setTAN] = useState("");
  const [UserPan, setUserPan] = useState(props.pan);
  const [empPrimaryPan, setEmpPrimaryPan] = useState("");

  const [officeAddress, setOfficeAddress] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);
  const [officeName, setOfficeName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [roleSet, setRoleSet] = useState("");
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [photoUrl, setPhotoUrl] = useState("https://tinyurl.com/4ypa9c6z");
  const [link, setLink] = useState("");
  const [isEditVisible, setIsEditVisible] = useState(true);
  const currentYear = new Date().getFullYear();
  const [referralActivated, setReferralActivated] = useState(false);
  const [form16BAvailable, setForm16BAvailable] = useState(false);
  // Calculate the current, previous, and next assessment years
  const currentAY = `${currentYear}-${currentYear + 1}`;
  const previousAY = `${currentYear - 1}-${currentYear}`;
  const [year] = useState(currentAY);

  const [employers, setEmployers] = useState([
    // Initial employer data
    { employerName: "", tan: "", empPAN: "" },
  ]);
  const [employerName, setEmployerName] = useState("");
  const [tan, setTan] = useState("");
  const [empPAN, setEmpPAN] = useState("");
  const [showInputFields, setShowInputFields] = useState(false);
  const [showAddButton, setShowAddButton] = useState(true);
  const [computationGenerated, setComputationGenerated] = useState(false);
  const [queryValue, setQueryValue] = useState("");
  const [previousQueries, setPreviousQueries] = useState([]);
  const [previousITRs, setPreviousITRs] = useState([]);
  const [userDistrict, setUserDistrict] = useState("");
  const [consultantData, setConsultantData] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [referralStats, setReferralStats] = useState({
    totalReferrals: 0,
    successfulReferrals: 0,
    earnings: 0
  });
  const [ackLink, setAckLink] = useState("");

  useEffect(() => {
    const loadReferralStats = async () => {
      if (authUser && authUser.email) {
        const match = authUser.email.match(/\+(.*?)@/);
        const pan = match[1].toUpperCase();
        const userDocRef = doc(db, "usersTable", pan);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setReferralStats({
            totalReferrals: userData.referrals?.length || 0,
            successfulReferrals: userData.referrals?.filter(r => r.status === "completed").length || 0,
            earnings: userData.referralEarnings || 0
          });
        }
      }
    };

    loadReferralStats();
  }, [authUser]);



  useEffect(() => {
    const fetchItrStatus = async () => {
      try {
        const itrDoc = await db
          .collection("itrWorking")
          .where("pan", "==", userData?.pan)
          .get();

        if (!itrDoc.empty) {
          setItrStatus(itrDoc.docs[0].data().isCompleted || false);
        }
      } catch (error) {
        console.error("Error fetching ITR status:", error);
      }
    };

    if (userData?.pan) {
      fetchItrStatus();
    }
  }, [userData?.pan]);

  useEffect(() => {
    const generateReferralCode = () => {
      // Generate a random 8-character alphanumeric code
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let result = "";
      for (let i = 0; i < 8; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    };

    const fetchOrCreateReferralCode = async () => {
      if (authUser && authUser.email) {
        const match = authUser.email.match(/\+(.*?)@/);
        const pan = match[1].toUpperCase();
        const userDocRef = doc(db, "usersTable", pan);

        try {
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const userData = userDoc.data();
            if (userData.referralCode) {
              setReferralCode(userData.referralCode);
            } else {
              // Generate new code and save to database
              const newCode = generateReferralCode();
              await updateDoc(userDocRef, { referralCode: newCode });
              setReferralCode(newCode);
            }
          }
        } catch (error) {
          console.error("Error handling referral code:", error);
        }
      }
    };

    fetchOrCreateReferralCode();
  }, [authUser]);

  const handleRazorPaySuccess = (verificationData) => {
    toast.success("Referral program activated successfully!");
    setReferralActivated(true);

    // Update user data in Firebase to mark referral as activated
    const updateReferralStatus = async () => {
      try {
        const match = authUser.email.match(/\+(.*?)@/);
        const pan = match[1].toUpperCase();
        const userDocRef = doc(db, "usersTable", pan);

        await updateDoc(userDocRef, {
          referralActivated: true,
          referralActivationDate: new Date().toISOString()
        });
      } catch (error) {
        console.error("Error updating referral status:", error);
      }
    };

    updateReferralStatus();
  };

  const handleRazorPayError = (errorMessage) => {
    toast.error(errorMessage);
  };

  const handleShareReferral = () => {
    const referralLink = `${window.location.origin}/signup?ref=${referralCode}`;
    setShowShareModal(true); // This will show the modal
  };

  // In Profile.js, inside the handleFormDownload function
  const handleFormDownload = async () => {
    try {
      // Extract PAN from email
      const match = authUser.email.match(/\+(.*?)@/);
      if (!match) {
        throw new Error("Invalid email format - PAN not found");
      }
      const pan = match[1].toUpperCase();

      // Get reference to user's tax data
      const itrWorkingRef = doc(db, "itrWorking", pan);
      const itrWorkingSnap = await getDoc(itrWorkingRef);

      if (!itrWorkingSnap.exists()) {
        toast.error("Tax data not found for this user");
        return;
      }

      const itrData = itrWorkingSnap.data();
      const yearData = itrData[year];

      if (!yearData) {
        toast.error(`No data found for assessment year ${year}`);
        return;
      }

      // Call modifyPdf with the correct parameters
      await modifyPdf(pan, year);

      // Add notice to database
      const noticeRef = doc(db, "notices", "computation");
      await updateDoc(noticeRef, {
        [pan]: {
          message: `Computation sheet generated for PAN: ${pan}`,
          timestamp: new Date().toISOString()
        }
      }, { merge: true });

      toast.success("Form 16 downloaded successfully");
    } catch (error) {
      console.error("Error downloading Form 16:", error);
      toast.error(error.message || "Failed to download Form 16");
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      if (!authUser?.email) return;

      const match = authUser.email.match(/\+(.*?)@/);
      const pan = match[1].toUpperCase();

      const docRef = doc(db, "itrWorking", pan);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        // Check for computationGenerated inside the current assessment year
        setComputationGenerated(data[currentAY]?.computationGenerated || false);
      }
    };
    fetchUserData();
  }, [authUser, currentAY]);

  useEffect(() => {
    const listen = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setAadhaar(userData?.userdata?.aadharNo);
        setIfscCode(userData?.userdata?.ifscCode);
        setEmployeeId(userData?.userdata?.employeeId);
        setAccountNumber(userData?.userdata?.bankAccountNo);
        // setPoliceStation(userData?.policeStation);
        setEmpPrimaryPan(userData?.incomeSalary[0]?.empPAN);
        setOfficeAddress(userData?.userdata?.officeAddress);
        setOfficeName(userData?.incomeSalary[0]?.employerName);
        setEmail(userData?.userdata?.email);
        setDesignation(userData?.incomeSalary[0]?.designation);
        setTAN(userData?.incomeSalary[0]?.tan);
        setMobile(userData?.userdata?.mobile);
        setRoleSet(userData?.userdata?.userType);
        if (authUser?.photoURL) {
          setPhotoUrl(authUser.photoURL);
        }
        console.log(Object.values(userData?.incomeSalary).length);
        if (Object.values(userData?.incomeSalary).length < 1) {
          setShowAddButton(true);
        }
        const match = user.email.match(/\+(.*?)@/);
        const pan = match[1].toUpperCase();

        const itrWorkingRef = doc(db, "itrWorking", pan);
        const itrWorkingSnap = await getDoc(itrWorkingRef);

        if (itrWorkingSnap.exists()) {
          const itrData = itrWorkingSnap.data();
          console.log("ITRWorking Data:", itrData); // Debug log

          // Check if form16BGenerated exists (case-sensitive)
          if (itrData.form16BGenerated === true) {
            console.log("Form16B is available!"); // Debug log
            setForm16BAvailable(true);
          } else {
            console.log("Form16B exists but is false/undefined");
            setForm16BAvailable(false);
          }
        } else {
          console.log("ITRWorking document does not exist");
          setForm16BAvailable(false);
        }

        const currentYear = process.env.REACT_APP_CURRENT_YEAR;
        const questRef = doc(db, currentYear.toString(), pan);
        const questSnap = await getDoc(questRef);
        if (questSnap.exists()) {
          if (questSnap.data()["path"] === -1) {
            setLink("");
          } else {
            setLink(questSnap.data()["path"]);
          }
        }
        if (userData?.form16BGenerated) {
          setForm16BAvailable(true);
        }

        // const employerRef = doc(db, currentYear.toString(), pan);
        // const employerSnap = await getDoc(employerRef);
        // setEmployers(employerSnap.data()?.Employers);
        setEmployers(Object.values(userData?.incomeSalary));

        const fetchPreviousQueries = async () => {
          if (authUser && authUser.email) {
            const match = authUser.email.match(/\+(.*?)@/);
            const pan = match[1].toUpperCase();

            const queriesCollection = collection(db, "queries");
            const q = query(queriesCollection, where("pan", "==", pan));
            const querySnapshot = await getDocs(q);

            const queries = querySnapshot.docs.map((doc) => ({
              id: doc.id, // Add document ID
              query: doc.data().query,
              status: doc.data().status,
            }));
            console.log("Fetched queries:", queries);
            setPreviousQueries(queries);
          }
        };
        console.log("employer: ", employers);
        fetchPreviousQueries(); // Add this line

        const fetchDistrictAndConsultantData = async () => {
          if (authUser && authUser.email) {
            const match = authUser.email.match(/\+(.*?)@/);
            const pan = match[1].toUpperCase();

            // Fetch district from EnquirySheet collection
            const enquirySheetCollection = collection(db, "EnquirySheet");
            const enquirySheetDoc = await getDoc(
              doc(enquirySheetCollection, pan)
            );
            const district = enquirySheetDoc.data();
            console.log("Fetched district:", district[year]?.district);
            console.log("district YEar:", year);
            setUserDistrict(district[year]?.district);

            // Fetch consultant data from mapFilter collection
            const mapFilterCollection = collection(db, "mapFilter");
            const consultantDoc = await getDoc(
              doc(mapFilterCollection, "consultant")
            );
            const consultantData = consultantDoc.data();
            console.log("Fetched consultant data:", consultantData);
            setConsultantData(consultantData);
          }
        };
        fetchDistrictAndConsultantData();
      }
    });
    return () => {
      listen();
    };
  }, [userData, authUser]);

  useEffect(() => {
    const checkForm16B = async () => {
      if (authUser) {
        const match = authUser.email.match(/\+(.*?)@/);
        const pan = match[1].toUpperCase();
        const docRef = doc(db, "itrWorking", pan);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          console.log("Form16B exists:", data.form16BGenerated);
          setForm16BAvailable(!!data.form16BGenerated);
        }
      }
    };

    checkForm16B();
  }, [authUser]);

  useEffect(() => {
    const fetchPreviousITRs = async () => {
      if (authUser && authUser.email) {
        const match = authUser.email.match(/\+(.*?)@/);
        const pan = match[1].toUpperCase();

        const currentYear = new Date().getFullYear();
        const previousYears = [];
        for (let i = 0; i < 2; i++) {
          const year = `${currentYear - i - 1}-${currentYear - i}`;
          previousYears.push(year);
        }

        const previousITRs = [];
        for (const year of previousYears) {
          const storageRef = ref(
            storage,
            `ITRAcknowledgement/AY ${year}/${pan}_ITRAcknowledgement.pdf`
          );
          try {
            const fileUrl = await getDownloadURL(storageRef);
            previousITRs.push({ year, link: fileUrl });
          } catch (error) {
            console.error("Error getting file URL: ", error);
          }
        }
        setPreviousITRs(previousITRs);
      }
    };
    fetchPreviousITRs();
  }, [authUser, storage]);

  const handleAadharChange = (value) => {
    const inputValue = value;
    const formattedAadhar = formatAadharNumber(inputValue);
    setAadhaar(formattedAadhar);
  };

  const accountInfo = [
    {
      label: t("Bank Account Number"),
      value: accountNumber,
      name: "accountNumber",
      setValue: setAccountNumber,
    },
    {
      label: t("Re-enter Bank Account Number"),
      value: accountNumber,
      name: "accountNumber",
      setValue: setAccountNumber,
    },
    {
      label: t("IFSC Code"),
      value: ifscCode,
      name: "ifscCode",
      setValue: setIfscCode,
    },
    {
      label: t("Aadhaar Number"),
      value: aadhaar,
      name: "aadhaar",
      setValue: setAadhaar,
    },
    // {
    //   label: t("Police Station"),
    //   value: policeStation,
    //   name: "policeStation",
    //   setValue: setPoliceStation,
    // },
    {
      label: t("Employee ID"),
      value: employeeId,
      name: "employeeId",
      setValue: setEmployeeId,
    },
    // {
    //   label: t("Designation"),
    //   value: Designation,
    //   name: "Designation",
    //   setValue: setDesignation,
    // },
    // {
    //   label: t("TAN"),
    //   value: TAN,
    //   name: "TAN",
    //   setValue: setTAN,
    // },
    {
      label: t("PAN"),
      value: UserPan,
      name: "PAN",
      setValue: setUserPan,
    },
    // {
    //   label: t("Office Address"),
    //   value: officeAddress,
    //   name: "officeAddress",
    //   setValue: setOfficeAddress,
    // },
    {
      label: t("Email"),
      value: email,
      name: "email",
      setValue: setEmail,
    },
    {
      label: t("Mobile"),
      value: mobile,
      name: "mobile",
      setValue: setMobile,
    },
    {
      label: t("Your Referral Code"),
      value: referralCode,
      name: "referralCode",
      setValue: setReferralCode,
    },
  ];

  const primaryInfo = [
    {
      label: t("Employee ID"),
      value: employeeId,
      name: "employeeId",
      setValue: setEmployeeId,
    },
    {
      label: t("Designation"),
      value: Designation,
      name: "Designation",
      setValue: setDesignation,
    },
    {
      label: t("TAN"),
      value: TAN,
      name: "TAN",
      setValue: setTAN,
    },
    {
      label: t("PAN"),
      value: empPrimaryPan,
      name: "PAN",
      setValue: setEmpPrimaryPan,
    },
    {
      label: t("Office Address"),
      value: officeAddress,
      name: "officeAddress",
      setValue: setOfficeAddress,
    },
    {
      label: t("Office Name"),
      value: officeName,
      name: "officeName",
      setValue: setOfficeName,
    },
  ];

  const formatAadharNumber = (value) => {
    const numericValue = value.replace(/\D/g, "");
    let formattedValue = "";
    for (let i = 0; i < numericValue.length; i++) {
      if (i > 0 && i % 4 === 0) {
        formattedValue += " ";
      }
      formattedValue += numericValue[i];
    }
    return formattedValue;
  };

  // Uploading data into the database
  const updateEmployeer = useCallback((employers) => {
    const match = authUser.email.match(/\+(.*?)@/);
    const pan = match[1].toUpperCase();
    console.log(employers);
    // const tanSource = doc(db, year, pan);
    // try {
    // console.log(employers);
    //   updateDoc(tanSource, { Employers: employers });
    // } catch (err) {
    //   console.log(err);
    // }

    const itrWorkingRef = doc(db, "itrWorking", pan);

    const employerData = {
      incomeFromSalaries: employers.reduce((acc, emp, index) => {
        return {
          ...acc,
          [index]: {
            employerName: emp.employerName,
            tan: emp.tan,
            empPAN: emp.empPAN,
            address: emp.address || "",
            city: emp.city || "",
            designation: emp.designation || "",
            natureOfEmployment: emp.natureOfEmployment || "",
            pincode: emp.pincode || 0,
            salary: emp.salary || 0,
            salaryType: emp.salaryType || "",
            state: emp.state || "",
            allowance: {
              conveyance: emp?.allowance?.conveyance || 0,
              edu: emp?.allowance?.edu || 0,
              hra: emp?.allowance?.hra || 0,
              other: emp?.allowance?.other || 0,
              travel: emp?.allowance?.travel || 0,
              uniform: emp?.allowance?.uniform || 0,
            },
          },
        };
      }, {}),
    };
    // const assessmentYear = "2024-2025";
    console.log(employerData.incomeFromSalaries);
    try {
      updateDoc(itrWorkingRef, {
        [`${year}.incomeFromSalaries`]: employerData.incomeFromSalaries,
      });
      toast.success(t("Details Updated Successfully!"));
    } catch (err) {
      console.log(err);
    }
  });

  // updating the Employeer state
  const addEmployer = (e) => {
    e.preventDefault();
    if (employerName && tan && empPAN) {
      setEmployers([...employers, { employerName, tan, empPAN }]);
      updateEmployeer([...employers, { employerName, tan, empPAN }]);
      setEmployerName("");
      setTanNumber("");
      setPanNumber("");
      setShowInputFields(false); // hide input fields after submission
      setShowAddButton(false);
    }
  };

  // Function to handle Aadhar number input change

  const onSubmit = useCallback((e) => {
    e.preventDefault();
    setEdit(false);
    const formData = new FormData(e.target);
    // console.log(accountInfo.accountNumber);
    // console.log(formData.get("accountNumber"));
    const obj = {
      bankAccountNo: formData.get("accountNumber"),
      ifscCode: formData.get("ifscCode"),
      aadhaarNo: formData.get("aadhaar"),
      // policeStation: formData.get("policeStation"),
      employeeId: formData.get("employeeId"),
      // Designation:formData.get("Designation"),
      // TAN:formData.get("TAN"),
      // officeAddress: formData.get("officeAddress"),
      // email: formData.get("email"),
      mobile: formData.get("mobile"),
    };

    const match = authUser.email.match(/\+(.*?)@/);
    const pan = match[1].toUpperCase();
    const docRef = doc(db, "usersTable", pan);
    try {
      // updateDoc(docRef, obj);
      updateDoc(docRef, { ...obj }, { merge: true });
      // console.log("Document updated successfully!");
      toast.success(t("Account Details Updated Successfully!"));
      // navigate to home page
      navigate("/dashboard", { replace: true });
    } catch (error) {
      console.error("Something went wrong, please try again");
      console.error("Error updating document: ", error);
    }
  }, []);

  const onPrimarySubmit = useCallback((e) => {
    e.preventDefault();
    setEditPrimary(false);
    const formData = new FormData(e.target);
    // console.log(accountInfo.accountNumber);
    // console.log(formData.get("accountNumber"));
    console.log("form data", formData);
    const itrWorkingObj = {
      designation: formData.get("Designation"),
      tan: formData.get("TAN"),
      empPAN: formData.get("PAN"),
      address: formData.get("officeAddress"),
      employerName: formData.get("officeName"),
    };
    const userDetailsObj = {
      employeeId: formData.get("employeeId"),
      officeAddress: formData.get("officeAddress"),
    };

    console.log("officeName :", officeName);
    console.log("officeAddress :", officeAddress);
    // console.log("pan", pan);
    console.log("employeeId :", employeeId);
    console.log("Designation :", Designation);
    // console.log("TAN", TAN);

    const match = authUser.email.match(/\+(.*?)@/);
    const pan = match[1].toUpperCase();
    const itrWorkingDocRef = doc(db, "itrWorking", pan);
    // const assessmentYear = "2024-2025";
    try {
      updateDoc(itrWorkingDocRef, {
        [`${year}.incomeFromSalaries.0.designation`]: itrWorkingObj.designation,
        [`${year}.incomeFromSalaries.0.tan`]: itrWorkingObj.tan,
        [`${year}.incomeFromSalaries.0.empPAN`]: itrWorkingObj.empPAN,
        [`${year}.incomeFromSalaries.0.address`]: itrWorkingObj.address,
        [`${year}.incomeFromSalaries.0.employerName`]:
          itrWorkingObj.employerName,
      });
      // console.log("Document updated successfully!");
      toast.success(t("Details Updated Successfully!"));
      // navigate to home page
      navigate("/dashboard", { replace: true });
    } catch (error) {
      // console.error("Something went wrong, please try again");
      console.error("Error updating document: ", error);
    }

    const userDetailsDocRef = doc(db, "usersTable", pan);
    try {
      updateDoc(userDetailsDocRef, { ...userDetailsObj }, { merge: true });
      console.log("userDetails document updated successfully!");
      toast.success(t("Details Updated Successfully!"));
    } catch (error) {
      console.error("Error updating userDetails document: ", error);
    }
  }, []);

  const editAccountInfo = () => {
    setEdit(true);
  };

  const editPrimaryInfo = () => {
    setEditPrimary(true);
  };

  const editOtherEmpInfo = () => {
    setEditOtherEmp(true);
  };

  const submitAccountInfo = () => {
    setEdit(false);
  };

  const submitPrimaryInfo = () => {
    setEditPrimary(false);
  };

  const submitOtherEmpInfo = () => {
    setEditOtherEmp(false);
  };

  const onEmployerSubmit = (e) => {
    e.preventDefault();
    // Handle submission of edited other employers data
    console.log("Submit other employers data:", employers);

    // Update the database with the edited employer details
    const match = authUser.email.match(/\+(.*?)@/);
    const pan = match[1].toUpperCase();
    const docRef = doc(db, "itrWorking", pan);
    // const assessmentYear = "2024-2025";
    try {
      // updateDoc(docRef, { Employers: employers });
      updateDoc(docRef, {
        [`${year}.incomeFromSalaries.1`]: employers[1],
      });
      console.log("Employer details updated successfully!");
      toast.success(t("Details Updated Successfully!"));
    } catch (error) {
      console.error("Error updating employer details:", error);
    }

    setEditOtherEmp(false); // Reset edit mode after submission
  };

  const onEmployerChange = (index, fieldName, value) => {
    const updatedEmployers = [...employers];
    updatedEmployers[index][fieldName] = value;
    setEmployers(updatedEmployers);
  };

  const deleteEmployer = (index) => {
    const updatedEmployers = [...employers];
    console.log(updatedEmployers);
    updatedEmployers.splice(index, 1); // Remove the employer at the specified index
    console.log(updatedEmployers);
    setEmployers(updatedEmployers); // Update the state with the modified employers array

    const employerData = {
      incomeFromSalaries: {
        employerName: "",
        tan: "",
        empPAN: "",
        address: "",
        city: "",
        designation: "",
        natureOfEmployment: "",
        pincode: 0,
        salary: 0,
        salaryType: "",
        state: "",
        allowance: {
          conveyance: 0,
          edu: 0,
          hra: 0,
          other: 0,
          travel: 0,
          uniform: 0,
        },
      },
    };

    // Update the database to reflect the changes
    const match = authUser.email.match(/\+(.*?)@/);
    const pan = match[1].toUpperCase();
    const docRef = doc(db, "itrWorking", pan);
    // const assessmentYear = "2024-2025";
    try {
      updateDoc(docRef, {
        [`'${year}'.incomeFromSalaries.1`]: employerData.incomeFromSalaries,
      });
      console.log("Employer deleted successfully!");
      toast.success(t("Employer Deleted Successfully!"));
    } catch (error) {
      console.error("Error deleting employer:", error);
    }
  };

  const userSignOut = () => {
    signOut(auth)
      .then(() => {
        // console.log("sign out successful");
      })
      .catch((error) => console.log(error));
  };
  const whatsappMeFxn = (phoneNumber) => {
    window.open(`https://wa.me/${phoneNumber}`);
  };
  // const whatsappMeFxnOffice = () => {
  //   window.open("https://wa.me/7276016790");
  // };

  const handleChange = (e) => {
    const maxAllowedSize = 0.5 * 1024 * 1024;
    if (e.target.files[0].size < maxAllowedSize) {
      setPhoto(e.target.files[0]);
      setLoading(false);
    } else {
      toast(t("Image size should be less than 500kb"), { icon: "📷" });
      setLoading(true);
      return;
    }
  };
  const handleGeneratePDF = () => {
    if (userData && userDeduction) {
      modifyPdf(userData, userDeduction);
    }
  };

  const updateImg = async (e) => {
    const authUser = auth.currentUser;
    if (authUser) {
      const match = authUser.email.match(/\+(.*?)@/);
      const userPan = match ? match[1].toUpperCase() : "";

      if (userPan) {
        const fileName = `${userPan}_profile.png`;
        const fileRef = ref(storage, "profileImg/" + fileName);

        setLoading(true);
        // eslint-disable-next-line
        const snapshot = await uploadBytes(fileRef, photo);
        const photoURL = await getDownloadURL(fileRef);

        updateProfile(authUser, { photoURL });

        setLoading(false);
        toast.success(
          t(
            "Profile Image Updated! It may take some time to display on profile..."
          )
        );
      }
    }
    window.location.reload(false);
  };

  const handleClick = async (year) => {
    const authUser = auth.currentUser;
    console.log("Attempting to retrieve acknowledgement for year:", year);

    if (authUser) {
      const match = authUser.email.match(/\+(.*?)@/);
      const userPan = match ? match[1].toUpperCase() : "";

      if (userPan) {
        const fileName = `${userPan}_ITRAcknowledgement.pdf`;
        const filePath = `ITRAcknowledgement/AY ${year}/${fileName}`;

        console.log("Retrieving file:", filePath);
        const storageRef = ref(storage, filePath);

        try {
          const fileUrl = await getDownloadURL(storageRef);
          setAckLink(fileUrl);
          // window.open(fileUrl, "_blank");
        } catch (error) {
          console.error("Error getting file URL:", error);
          toast.error("No document found for this year");
        }
      } else {
        toast.error("Unable to retrieve user PAN");
      }
    } else {
      toast.error("User not logged in");
    }
  };

  function addWeeks(date, weeks) {
    date.setDate(date.getDate() + 7 * weeks);

    return date;
  }

  const submitQuery = async () => {
    if (!queryValue) {
      toast.error("Query not entered");
      return;
    }

    try {
      // Get user data from Firebase - changed from "users" to "usersTable"
      const match = authUser.email.match(/\+(.*?)@/);
      const pan = match[1].toUpperCase();
      const userDoc = await getDoc(doc(db, "usersTable", pan));

      if (!userDoc.exists()) {
        toast.error("User data not found");
        return;
      }

      const userData = userDoc.data();

      // Rest of the function remains the same...
      const emailSent = await sendQueryEmail(
        {
          name: props.name,
          pan: props.pan,
          phone: props.phone,
          city: userData.city,
        },
        queryValue
      );

      if (!emailSent) {
        toast.error("Failed to send email notification");
      }

      raiseQuery(
        props.pan,
        props.name,
        mobile,
        new Date(),
        "not resolved",
        roleSet,
        queryValue,
        "",
        addWeeks(new Date(), 4)
      );

      toast.success("Query submitted successfully!");
      setQueryValue("");
    } catch (error) {
      console.error("Error submitting query:", error);
      toast.error("Failed to submit query");
    }
  };
  const districtMap = {
    Ahilyanagar: "northDef",
    Akola: "northDef",
    Amravati: "northDef",
    Beed: "northDef",
    Bhandara: "northDef",
    Buldhana: "northDef",
    Chandrapur: "northDef",
    "Chhatrapati Sambhajinagar": "northDef",
    Dharashiv: "northDef",
    Dhule: "northDef",
    Gadchiroli: "northDef",
    Gondia: "northDef",
    Hingoli: "northDef",
    Jalgaon: "northDef",
    Jalna: "northDef",
    Kolhapur: "southMH",
    Latur: "northDef",
    Mumbai: "pune",
    "Mumbai Suburban": "pune",
    Nagpur: "northDef",
    Nanded: "northDef",
    Nandurbar: "northDef",
    Nashik: "northDef",
    Palghar: "pune",
    Parbhani: "northDef",
    Pune: "pune",
    Raigad: "pune",
    Ratnagiri: "southMH",
    Sangli: "southMH",
    Satara: "southMH",
    Sindhudurg: "southMH",
    Solapur: "southMH",
    Thane: "pune",
    Wardha: "northDef",
    Washim: "northDef",
    Yavatmal: "northDef",
    Karnataka: "southMH",
    Army: "northDef",
    "South Goa": "southMH",
    "North Goa": "southMH",
    Tenkasi: "southMH",
  };

  let districtKey;
  if (
    userDistrict === "Pune" ||
    userDistrict === "Mumbai" ||
    userDistrict === "Mumbai Suburban" ||
    userDistrict === "Palghar" ||
    userDistrict === "Thane" ||
    userDistrict === "Raigad"
  ) {
    districtKey = "pune";
  } else if (
    userDistrict === "Satara" ||
    userDistrict === "Ratnagiri" ||
    userDistrict === "Sangli" ||
    userDistrict === "Solapur" ||
    userDistrict === "Kolhapur" ||
    userDistrict === "Sindhudurg" ||
    userDistrict === "Karnataka" ||
    userDistrict === "South Goa" ||
    userDistrict === "North Goa" ||
    userDistrict === "Tenkasi"
  ) {
    districtKey = "southMH";
  } else if (
    userDistrict === "Army" ||
    userDistrict === "Nashik" ||
    userDistrict === "Ahilyanagar" ||
    userDistrict === "Nandurbar" ||
    userDistrict === "Dhule" ||
    userDistrict === "Jalgaon" ||
    userDistrict === "Chhatrapati Sambhajinagar" ||
    userDistrict === "Beed" ||
    userDistrict === "Jalna" ||
    userDistrict === "Parbhani" ||
    userDistrict === "Hingoli" ||
    userDistrict === "Dharashiv" ||
    userDistrict === "Latur" ||
    userDistrict === "Nanded" ||
    userDistrict === "Buldhana" ||
    userDistrict === "Akola" ||
    userDistrict === "Amaravati" ||
    userDistrict === "Washim" ||
    userDistrict === "Yavatmal" ||
    userDistrict === "Wardha" ||
    userDistrict === "Nagpur" ||
    userDistrict === "Bhandara" ||
    userDistrict === "Gondia" ||
    userDistrict === "Chandrapur" ||
    userDistrict === "Gadchiroli"
  ) {
    districtKey = "northDef";
  } else if (userDistrict === "Private") {
    districtKey = "corporate";
  } else {
    districtKey = "pune";
  }

  const consultantContact = consultantData[districtKey];
  console.log("consultantContact", consultantContact);

  return (
    <div className="container-md mt-5">
      {/* profile image */}
      <center>
        <div className="box">
          {/* <!-- Button trigger modal --> */}
          {/* <button
            type="button"
            className="btn btn-primary m-2"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            {t("Update Profile Image")}
          </button> */}

          {/* <!-- Modal --> */}
          {/* <div
            className="modal fade"
            id="exampleModal"
            style={{ marginTop: "50px" }}
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {t("Update Profile Image")}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="text-center mt-2 ">
                    <img
                      src={photoUrl}
                      className="rounded-circle"
                      style={{ objectFit: "cover" }}
                      alt="user avatar"
                      width="150"
                      height="150"
                    // onChange={handleSelect}
                    ></img>
                    <input
                      className="row"
                      type="file"
                      accept="image/*"
                      onChange={handleChange}
                    ></input>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    {t("Close")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={loading || !photo}
                    onClick={updateImg}
                  >
                    {t("Save changes")}
                  </button>
                </div>
              </div>
            </div>
          </div> */}
          <button className="btn btn-signup btn-primary m-">
            <Link to="/auth/change_pwd">{t("Reset Password")}</Link>
          </button>
          <button className="btn btn-signup btn-danger m-2"
            onClick={userSignOut}
          >
            {t("Log Out")}
          </button>
        </div>
      </center>

      {/* accordion starts */}
      <div className="accordion" id="accordionExample">
        {/* account details starts */}
        <div className="accordion-item my-3 rounded-5 border-0 bg-dark-gray position-relative">
          <h2 className="accordion-header">
            <button
              className="accordion-button shadow-none text-light bg-dark-gray rounded-pill "
              // onClick={() => setIsEditVisible()}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              {t("Account Details")}
            </button>
          </h2>
          {/* {isEditVisible ? (
            <div
              className="accordion-body  d-flex justify-content-end"
              style={{
                position: "absolute",
                top: "-5px",
                right: "50px",
                zIndex: "100",
              }}
            >
              {!edit ? (
                <EditButton onTap={editAccountInfo} />
              ) : (
                <SubmitButton />
              )}
            </div>
          ) : (
            <></>
          )} */}
          <div
            id="collapseOne"
            // className="accordion-collapse collapse show pb-3"
            data-bs-parent="#accordionExample"
          >
            <form onSubmit={onSubmit}>
              {accountInfo.map((item, index) => {
                const isPolice = roleSet == "Policeman";
                const isEmail = item.name === "email";
                const isPan = item.name === "PAN";
                const isAadhaar = item.name === "aadhaar";

                {
                  /* if (!isPolice && index == 3) {
                  return null;
                } */
                }

                if (item.name === "referralCode") {
                  return (
                    <div className="accordion-body py-2" key={index}>
                      <label className="d-flex text-light justify-content-between">
                        {item.label}
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          name={item.name}
                          type="text"
                          className="form-control rounded-pill border-0 me-2"
                          value={item.value}
                          readOnly
                        />
                        <button
                          className="btn btn-sm btn-primary rounded-pill"
                          onClick={() => setShowShareModal(true)}
                        >
                          {t("Share")}
                        </button>
                      </div>
                      {showShareModal && (
                        <ShareOptionsModal
                          referralLink={`${window.location.origin}/signup?ref=${referralCode}`}
                          onClose={() => setShowShareModal(false)}
                        />
                      )}
                      {/* RazorPay activation block */}
                      {referralCode && !referralActivated && (
                        <div className="mt-3">
                          <p className="text-light">
                            Activate your referral program for ₹99 to start earning rewards
                          </p>
                          <ReferralRazorPay
                            referralCode={referralCode}
                            amount={99}
                            onSuccess={handleRazorPaySuccess}
                            onError={handleRazorPayError}
                          />
                        </div>
                      )}
                    </div>
                  );
                }
                console.log("computationGenerated:", computationGenerated);
                console.log("userData:", userData);
                console.log("Resolved PAN:", pan);
                console.log("currentAY:", currentAY);

                return (
                  <div className="accordion-body py-2" key={index}>
                    <label className="d-flex text-light justify-content-between">
                      {item.label}
                    </label>
                    {index !== 8 ? (
                      <input
                        name={item.name}
                        type="text"
                        className="form-control rounded-pill border-0"
                        placeholder={t("Enter ") + item.label}
                        value={item.value}
                        readOnly={
                          isEmail || isPan || (edit ? null : "readOnly")
                        }
                        pattern={isAadhaar ? "[0-9]{12}" : null}
                        onChange={(e) => item.setValue(e.target.value)}
                      />
                    ) : (
                      <textarea
                        name={item.name}
                        type="text"
                        className="form-control rounded-pill border-0"
                        placeholder={t("Enter ") + item.label}
                        value={item.value}
                        style={{ resize: "none" }}
                        readOnly={edit ? null : "readOnly"}
                        onChange={(e) => item.setValue(e.target.value)}
                      ></textarea>
                    )}
                  </div>
                );
              })}
              <div className="accordion-body pb-4 d-flex justify-content-end pe-5">
                {!edit ? (
                  <EditButton onTap={editAccountInfo} />
                ) : (
                  <SubmitButton />
                )}
              </div>
            </form>
          </div>
        </div>
        {/* account details ends */}

        {/* Employer starts */}
        <div className="accordion-item my-3 rounded-5 border-0 bg-dark-gray">
          <h2 className="accordion-header">
            <button
              className="accordion-button shadow-none text-light bg-dark-gray rounded-pill"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEmployer"
              aria-expanded="false"
              aria-controls="collapseEmployer"
            >
              {t("Employer Details")}
            </button>
          </h2>
          <div
            id="collapseEmployer"
            className="pb-2"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body py-2">
              <div
                style={{
                  background: "white",
                  borderRadius: "25px",
                  padding: "1rem",
                }}
              >
                <h4>{t("Primary Employer Details")}</h4>

                <form onSubmit={onPrimarySubmit}>
                  {primaryInfo.map((item, index) => {
                    return (
                      <div className="accordion-body py-2" key={index}>
                        <label className="d-flex text-dark justify-content-between">
                          {item.label}
                        </label>
                        {index !== 8 ? (
                          <input
                            name={item.name}
                            type="text"
                            className="form-control rounded-pill border border-secondary mt-2"
                            placeholder={t("Enter ") + item.label}
                            value={item.value}
                            readOnly={editPrimary ? null : "readOnly"}
                            onChange={(e) => item.setValue(e.target.value)}
                          />
                        ) : (
                          <textarea
                            name={item.name}
                            type="text"
                            className="form-control rounded-pill border-0"
                            placeholder={t("Enter ") + item.label}
                            value={item.value}
                            style={{ resize: "none" }}
                            readOnly={editPrimary ? null : "readOnly"}
                            onChange={(e) => item.setValue(e.target.value)}
                          ></textarea>
                        )}
                      </div>
                    );
                  })}
                  <div className="accordion-body pb-4 d-flex justify-content-end pe-5">
                    {!editPrimary ? (
                      <EditButton onTap={editPrimaryInfo} />
                    ) : (
                      <SubmitButton />
                    )}
                  </div>
                </form>
              </div>
            </div>

            <div className="accordion-body py-2">
              <div
                style={{
                  background: "white",
                  borderRadius: "25px",
                  padding: "1rem",
                }}
              >
                <h4>{t("Other Employer Details")}</h4>
                <form onSubmit={onEmployerSubmit}>
                  <div className="employer-container mt-3">
                    {employers.slice(1).map(
                      (
                        employer,
                        index // Starts from index 1
                      ) => (
                        <div key={index} className="card p-3">
                          <div className="mb-3">
                            <label
                              htmlFor="employerName"
                              className="form-label"
                            >
                              {t("Employer/Office/Company Name")}
                            </label>
                            <input
                              type="text"
                              className="form-control rounded-pill border border-secondary"
                              placeholder="Enter Employer/Office/Company Name"
                              value={employer.employerName}
                              readOnly={!editOtherEmp}
                              onChange={(e) =>
                                onEmployerChange(
                                  index + 1,
                                  "employerName",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="tanNumber" className="form-label">
                              {t("TAN (Deductor)")}
                            </label>
                            <input
                              type="text"
                              className="form-control rounded-pill border border-secondary"
                              pattern="^[A-Za-z]{4}\d{5}[A-Za-z]$"
                              placeholder="Enter TAN (Deductor)"
                              value={employer.tan}
                              readOnly={!editOtherEmp}
                              onChange={(e) =>
                                onEmployerChange(
                                  index + 1,
                                  "tan",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="panNumber" className="form-label">
                              {t("PAN (Deductor)")}
                            </label>
                            <input
                              type="text"
                              className="form-control rounded-pill border border-secondary"
                              placeholder="Enter PAN (Deductor)"
                              pattern="[A-Za-z\]{10}"
                              value={employer.empPAN}
                              readOnly={!editOtherEmp}
                              onChange={(e) =>
                                onEmployerChange(
                                  index + 1,
                                  "empPAN",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="d-flex justify-content-end">
                            <div className="mb-1 me-2">
                              {!editOtherEmp ? (
                                <EditButton onTap={editOtherEmpInfo} />
                              ) : (
                                <SubmitButton />
                              )}
                            </div>
                            <div className="mb-1">
                              <DeleteButton
                                onTap={() => deleteEmployer(index + 1)}
                              />{" "}
                              {/* Adjust index for deletion */}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </form>

                <div>
                  {showAddButton && ( // conditionally render add button
                    <button
                      className="btn btn-primary rounded-pill border-0 my-3"
                      style={{ backgroundColor: "#007BFF" }}
                      onClick={() => {
                        setShowInputFields(true);
                        setShowAddButton(false); // hide add button when clicked
                      }}
                    >
                      {t("Add Employer")}
                    </button>
                  )}
                  {showInputFields && ( // conditionally render input fields
                    <div className="card p-3 border-0">
                      <div className="mb-3">
                        <label htmlFor="employerName" className="form-label">
                          {t("Employer/Office/Company Name")}
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-pill border border-secondary"
                          placeholder="Enter Employer/Office/Company Name"
                          value={employerName}
                          onChange={(e) => setEmployerName(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="tanNumber" className="form-label">
                          {t("TAN (Deductor)")}
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-pill border border-secondary"
                          pattern="^[A-Za-z]{4}\d{5}[A-Za-z]$"
                          placeholder="Enter TAN (Deductor)"
                          value={tan}
                          onChange={(e) => setTan(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="panNumber" className="form-label">
                          {t("PAN (Deductor)")}
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-pill border border-secondary"
                          pattern="[A-Za-z\]{10}"
                          placeholder="Enter PAN (Deductor)"
                          value={empPAN}
                          onChange={(e) => setEmpPAN(e.target.value)}
                        />
                      </div>
                      <button
                        className="btn btn-success rounded-pill border-0 my-3"
                        onClick={addEmployer}
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Employer ends */}

        {/* Form 16 starts here */}

        <div className="accordion-item my-3 rounded-5 border-0 bg-dark-gray">
          <h2 className="accordion-header">
            <button
              className="accordion-button shadow-none text-light bg-dark-gray rounded-pill"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              {t("Form 16")}
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              {form16BAvailable ? (
                <button
                  className="btn btn-primary rounded-pill"
                  onClick={handleFormDownload}
                >
                  {t("Download Form 16")}
                </button>
              ) : (
                <p className="text-light">
                  {t("Form 16 will be available after processing is complete")}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Form 16 ends here */}
        <div className="accordion-item my-3 rounded-5 border-0 bg-dark-gray">
          <h2 className="accordion-header">
            <button
              className="accordion-button shadow-none text-light bg-dark-gray rounded-pill"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseAck"
              aria-expanded="false"
              aria-controls="collapseThree"
              onClick={() => handleClick(currentAY)}
            >
              {t("Acknowledgement for Current Year")}
            </button>
          </h2>
          <div
            id="collapseAck"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">

              {ackLink ? (
                <>
                  <iframe
                    src={ackLink}
                    width="100%"
                    height="600px"
                    style={{ border: "none" }}
                    title="Acknowledgement PDF"
                  />

                  <a
                    href={ackLink}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      marginTop: "10px",
                      padding: "8px 16px",
                      backgroundColor: "#007bff",
                      color: "#fff",
                      textDecoration: "none",
                      borderRadius: "4px"
                    }}
                  >
                    Download PDF
                  </a>
                </>

              ) : (
                <p className="text-light">
                  {t("Form 16 will be available after processing is complete")}
                </p>
              )}
            </div>
          </div>
        </div>



        {/* Contact starts */}
        <div className="accordion-item my-3 rounded-5 border-0 bg-dark-gray">
          <h2 className="accordion-header">
            <button
              className="accordion-button shadow-none text-light bg-dark-gray rounded-pill"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              {t("Contact")}
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse p-2"
            data-bs-parent="#accordionExample"
          >
            {/* contact detail 1 starts */}
            <div className="card contact-card m-4">
              <div className="row no-gutters px-4">
                <div className="col-md-8 d-flex justify-content-center p-3">
                  <div className="col-3 d-flex align-items-center">
                    <img
                      src="assets/images/atharv.jpg"
                      className="rounded-circle img-thumbnail img-fluid object-fit-cover"
                      alt="Profile avatar"
                      width="100px"
                      height="100px"
                    // onChange={handleSelect}
                    ></img>
                  </div>

                  <div className="col-9 d-flex justify-content-center align-items-center">
                    <div className="card-body">
                      <h5 className="card-title">
                        {t("Atharv Sawant (Founder & Chairman)")}
                      </h5>
                      <p className="card-text">+91 9511926790 / 020-48555501</p>
                      {/* <p className="card-text">020 48555501</p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-4 d-flex justify-content-center align-items-center">
                  <div className="m-2">
                    <a href="tel:9511926790">
                      <button type="button" className="btn btn-primary">
                        {t("Call")}
                      </button>
                    </a>
                  </div>
                  <div className="m-2">
                    <button
                      onClick={() => whatsappMeFxn(919511926790)}
                      type="button"
                      className="btn btn-secondary whatsapp-btn"
                    >
                      {t("Whatsapp")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* contact detail 1 ends */}

            {/* contact detail 2 starts */}
            <div className="card contact-card m-4">
              <div className="row no-gutters px-4">
                <div className="col-md-8 d-flex justify-content-center p-3">
                  <div className="col-3 d-flex align-items-center">
                    <img
                      src="assets/images/icons/favicon.png"
                      className="rounded-circle img-thumbnail img-fluid object-fit-cover"
                      alt="Profile avatar"
                      width="100px"
                      height="100px"
                    ></img>
                  </div>

                  <div className="col-9 d-flex justify-content-center align-items-center">
                    <div className="card-body">
                      {/* <h5 className="card-title">{t("Tax Sarthi Office")}</h5> */}
                      <h5 className="card-title">
                        {t(`${consultantContact?.name}`)}
                      </h5>
                      <p className="card-text">{consultantContact?.phone}</p>
                      <p className="card-email">{consultantContact?.email}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 d-flex justify-content-center align-items-center">
                  <div className="m-2">
                    <a href={`tel: +91 ${consultantContact?.phone}`}>
                      <button type="button" className="btn btn-primary">
                        {t("Call")}
                      </button>
                    </a>
                  </div>
                  <div className="m-2">
                    <button
                      onClick={() =>
                        whatsappMeFxn("91" + consultantContact?.phone)
                      }
                      type="button"
                      className="btn btn-secondary whatsapp-btn"
                    >
                      {t("Whatsapp")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* contact detail 2 ends */}
          </div>
        </div>
        {/* Contact ends */}

        {/* Raise Query starts */}
        <div className="accordion-item my-3 rounded-5 border-0 bg-dark-gray">
          <h2 className="accordion-header">
            <button
              className="accordion-button shadow-none text-light bg-dark-gray rounded-pill"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              {t("Raise Query")}
            </button>
          </h2>
          <div
            id="collapseFive"
            className="accordion-collapse collapse p-2 m-2"
            data-bs-parent="#accordionExample"
          >
            <label className="d-flex mb-2 text-light justify-content-between">
              {t("Enter Query")}
            </label>
            <input
              type="text-area"
              className="form-control rounded-pill border-0"
              value={queryValue}
              onChange={(e) => {
                setQueryValue(e.target.value);
              }}
              id="query input field"
            ></input>
            <button
              className="btn btn-secondary rounded-pill border-0 my-3"
              onClick={submitQuery}
            >
              {t("Submit")}
            </button>
          </div>
        </div>
        {/* Raise Query ends */}

        {/* Previous Queries section */}
        <div className="accordion-item my-3 rounded-5 border-0 bg-dark-gray">
          <h2 className="accordion-header">
            <button
              className="accordion-button shadow-none text-light bg-dark-gray rounded-pill"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              {t("Previous Queries")}
            </button>
          </h2>
          <div
            id="collapseSix"
            className="accordion-collapse collapse p-2"
            data-bs-parent="#accordionExample"
          >
            {/* Render previous queries here */}
            {previousQueries.map((query, index) => (
              <div key={index} className="query-item">
                <div style={{ color: "white", marginLeft: "10px" }}>
                  Query : {query.query}
                  <span
                    style={{
                      color: "white",
                      fontWeight: "800",
                      fontSize: "20px",
                      marginLeft: "300px",
                    }}
                  >
                    Status : {query.status}
                  </span>
                </div>

                {/* Add any other details you want to display */}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* accordion ends */}
    </div>
  );
};

export default function ProfileErrorBoundary(props) {
  return (
    <ErrorBoundary>
      <Profile
        name={props.name}
        pan={props.pan}
        phone={props.phone}
        userType={props.userType}
      />
    </ErrorBoundary>
  );
}
